module.exports = __webpack_public_path__ + "static/media/edit_order_button_grey.05b2d094.svg";